import { useEffect, useState } from "react";
import Button from "../Primitive/Button"
import Card from "../Primitive/Card"
import "../../../Styles/main.scss"
import UserCard from "../Components/UserCard"
import { NewMemberResponse } from "../../../Types/Responses/NewMemberResponse"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../App/store"
import { setNewMembersData } from "../SharedSlices/NewestMembersSlice"
import { LoadingAnimation } from "../Components/SvgIcons"
import { useNavigate, useParams } from "react-router"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import { profileDefault } from "../../../App/GlobaleVariables"
import { newestMemberGetRequest } from "./NewestMemberGetRequest"
import { RoleType } from "../../../App/enums"

function NewestMembersCard(props: { otherUserId?: number }) {
    const newMembersState = useSelector((state: RootState) => state.newMembers.newMembersSlice.members)
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(true)
    const translation = useSelector(selectTranslations)
    const userDataState = useSelector((state: RootState) => state.userDataSlice)
    const navigate = useNavigate()
    const { id } = useParams()
    const filterNumber = 3

    const onRouteChange = () => {
        switch (role) {
            case RoleType.USER:
                const userPath = "/newest-members"
                navigate(userPath)
                window.scrollTo(0, 0)
                break
            case RoleType.ORGANIZATION:
                const organizationPath = `/newest-members/${id}`
                navigate(organizationPath)
                window.scrollTo(0, 0)
                break
            default:
                break
        }
    }

    const onNavigationToUserProfile = (userId: number) => {
        switch (role) {
            case RoleType.USER:
                const userPath = `/user/${userId}`
                navigate(userPath)
                window.scrollTo(0, 0)
                break
            case RoleType.ORGANIZATION:
                const organizationPath = `/user/${userId}/${id}`
                navigate(organizationPath)
                window.scrollTo(0, 0)
                break
            default:
                break
        }
    }

    useEffect(() => {
        let isMounted = true

        newestMemberGetRequest()
            .then((response: NewMemberResponse) => {
                if (isMounted && response.status === 200) {
                    dispatch(setNewMembersData(response.data))
                    setIsLoading(false)
                }
            })
            .catch(error => {
                console.log(error)
            })
        return () => {
            isMounted = false
        }
    }, [dispatch])

    const members = newMembersState.filter(member => {
        return member.id !== userDataState.id && member.id !== props.otherUserId!
    })

    return (
        <>
            {isLoading ? (
                <div className="new-members-card__loading-card">
                    <LoadingAnimation />
                </div>
            ) : (
                <div className="new-members-card">
                    <Card>
                        <div className="new-members-card__members">
                            {members?.slice(0, filterNumber).map((item, index) => {
                                return (
                                    <div
                                        key={item.id}
                                        className={`new-members-item  ${
                                            members.length <= filterNumber
                                                ? index === members.length - 1
                                                    ? "new-members-item--no-border"
                                                    : "new-members-item--border"
                                                : index === filterNumber - 1
                                                ? "new-members-item--no-border"
                                                : "new-members-item--border"
                                        }`}
                                    >
                                        <UserCard
                                            onClick={() => onNavigationToUserProfile(item.id!)}
                                            imageSrc={item.profile_photo?.url_path || profileDefault}
                                            text={item.first_name + " " + item.last_name}
                                            userCardStyle={`new-members-item`}
                                            leftPanelStyle={"left-panel"}
                                            middlePanelStyle={"middle-panel"}
                                            rightPanelStyle={"right-panel"}
                                            profileImageStyle={"image image__profile image__profile--fit image__profile--size-small"}
                                            textStyle={"text"}
                                            textStyleMore25={"text"}
                                            rightTextStyle={"right-text"}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                        <div className="new-members-card__button-container">
                            <div className="new-members-card__button">
                                <Button
                                    onClick={onRouteChange}
                                    className="button button--border-radius-09 button--color-grey button--hover-darker button--cursor-pointer button--text-color-grey button--font-size-small button--font-weight-400  "
                                >
                                    {translation.seeAllResults}
                                </Button>
                            </div>
                        </div>
                    </Card>
                </div>
            )}
        </>
    )
}

export default NewestMembersCard
